import { openBlock as b, createBlock as f, Transition as v, withCtx as $, renderSlot as z, nextTick as C } from "vue";
const E = {
  __name: "SlideDownTransition",
  props: {
    speed: {
      type: Number,
      default: 0.3
    },
    appear: {
      type: Boolean,
      default: !1
    }
  },
  setup(s) {
    const r = s;
    function g(t) {
      t.style.height = "0", t.style.opacity = "0", t.style.overflow = "hidden";
      const n = getComputedStyle(t).marginTop, o = getComputedStyle(t).marginBottom, e = getComputedStyle(t).paddingTop, a = getComputedStyle(t).paddingBottom;
      t.dataset.originalMarginTop = n, t.dataset.originalMarginBottom = o, t.dataset.originalPaddingTop = e, t.dataset.originalPaddingBottom = a, t.style.marginTop = "0", t.style.marginBottom = "0", t.style.paddingTop = "0", t.style.paddingBottom = "0";
    }
    function m(t, n) {
      const o = t.dataset.originalMarginTop || "", e = t.dataset.originalMarginBottom || "", a = t.dataset.originalPaddingTop || "", p = t.dataset.originalPaddingBottom || "", d = r.speed, i = t.cloneNode(!0);
      i.style.position = "absolute", i.style.visibility = "hidden", i.style.height = "auto", i.style.marginTop = o, i.style.marginBottom = e, i.style.paddingTop = a, i.style.paddingBottom = p, t.parentNode.appendChild(i);
      const h = i.offsetHeight;
      t.parentNode.removeChild(i), t.style.transition = `height ${d}s cubic-bezier(0.4,0,0.2,1), opacity ${d}s cubic-bezier(0.4,0,0.2,1), margin-top ${d}s cubic-bezier(0.4,0,0.2,1), margin-bottom ${d}s cubic-bezier(0.4,0,0.2,1), padding-top ${d}s cubic-bezier(0.4,0,0.2,1), padding-bottom ${d}s cubic-bezier(0.4,0,0.2,1)`, requestAnimationFrame(() => {
        t.style.height = `${h}px`, t.style.opacity = "1", t.style.marginTop = o, t.style.marginBottom = e, t.style.paddingTop = a, t.style.paddingBottom = p;
      }), t.addEventListener("transitionend", function l(T) {
        T.propertyName === "height" && (t.removeEventListener("transitionend", l), n());
      });
    }
    function y(t) {
      t.style.height = "", t.style.opacity = "", t.style.overflow = "", t.style.transition = "", t.style.marginTop = "", t.style.marginBottom = "", t.style.paddingTop = "", t.style.paddingBottom = "", delete t.dataset.originalMarginTop, delete t.dataset.originalMarginBottom, delete t.dataset.originalPaddingTop, delete t.dataset.originalPaddingBottom;
    }
    function c(t) {
      t.style.height = `${t.scrollHeight}px`, t.style.opacity = "1", t.style.overflow = "hidden";
      const n = getComputedStyle(t).marginTop, o = getComputedStyle(t).marginBottom, e = getComputedStyle(t).paddingTop, a = getComputedStyle(t).paddingBottom;
      t.dataset.originalMarginTop = n, t.dataset.originalMarginBottom = o, t.dataset.originalPaddingTop = e, t.dataset.originalPaddingBottom = a, t.style.marginTop = n, t.style.marginBottom = o, t.style.paddingTop = e, t.style.paddingBottom = a;
    }
    function u(t, n) {
      const o = r.speed;
      t.style.transition = `opacity ${o}s cubic-bezier(0.4,0,0.2,1), height ${o}s cubic-bezier(0.4,0,0.2,1), margin-top ${o}s cubic-bezier(0.4,0,0.2,1), margin-bottom ${o}s cubic-bezier(0.4,0,0.2,1), padding-top ${o}s cubic-bezier(0.4,0,0.2,1), padding-bottom ${o}s cubic-bezier(0.4,0,0.2,1)`, C(() => {
        t.style.opacity = "0", t.style.height = "0", t.style.marginTop = "0", t.style.marginBottom = "0", t.style.paddingTop = "0", t.style.paddingBottom = "0";
      }), t.addEventListener("transitionend", function e(a) {
        a.propertyName === "height" && (t.removeEventListener("transitionend", e), n());
      });
    }
    function B(t) {
      t.style.height = "", t.style.opacity = "", t.style.overflow = "", t.style.transition = "", t.style.marginTop = "", t.style.marginBottom = "", t.style.paddingTop = "", t.style.paddingBottom = "";
    }
    return (t, n) => (b(), f(v, {
      appear: s.appear,
      onBeforeEnter: g,
      onEnter: m,
      onAfterEnter: y,
      onBeforeLeave: c,
      onLeave: u,
      onAfterLeave: B
    }, {
      default: $(() => [
        z(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["appear"]));
  }
};
export {
  E as _
};
